import {
  Popover,
  ListItemText,
  ListItemButton,
  ListItem,
  List as MUIList,
  IconButton,
  Divider,
  Badge,
  Box,
} from '@mui/material'
import { useState } from 'react'
import NotificationIcon from '@/assets/icons/notification.svg'
import { useNavigate } from 'react-router-dom'
import { useInboxManagementContext } from '@/context/InboxContext'
import { readNotification } from '@/api'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`
export const NotificationPopover = () => {
  const { bellNotifications, mutateBellNotifications } =
    useInboxManagementContext()
  const unreadCount = bellNotifications?.unReadNotificationCount || 0
  const notifications = bellNotifications?.data || []
  console.log('bell notifications here ', bellNotifications)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const navigate = useNavigate()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleNavigate = async (notification: {
    id: number
    ticketNo?: string
  }) => {
    try {
      const role = JSON.parse(localStorage.getItem('role') || '""')
      const userId = JSON.parse(localStorage.getItem('userId') || '""')
      const ticketNo = notification.ticketNo

      if (!ticketNo) {
        console.warn('Missing ticketNo in notification:', notification)
        return
      }

      let isProcessed = false

      try {
        const url = `${DND_SERVICE}/v2/ticket-view/search?page=0&size=10&keyword=${encodeURIComponent(
          ticketNo,
        )}&roleName=${encodeURIComponent(role)}&userID=${encodeURIComponent(userId)}&isProcessed=false`

        const { data } = await useAxios.get(url)
        const content = data?.data?.content ?? []

        if (!Array.isArray(content) || content.length === 0) {
          isProcessed = true
        }
      } catch (err) {
        console.error('Error fetching ticket data:', err)
      }

      await readNotification(notification.id)
      await mutateBellNotifications()
      handleClose()

      window.location.href = `/maintenance-tickets?ticketNo=${encodeURIComponent(ticketNo)}&isProcessed=${isProcessed}`
    } catch (error) {
      console.error('Navigation error:', error)
    }
  }

  const open = Boolean(anchorEl)
  const id = open ? 'notification-popover' : undefined

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <Badge
          badgeContent={unreadCount}
          color="error"
          overlap="circular"
          invisible={unreadCount === 0}
        >
          <NotificationsNoneIcon style={{ fontSize: 24, color: '#000' }} />
        </Badge>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            width: '350px',
            padding: '10px',
          },
        }}
      >
        <Divider />
        <MUIList dense>
          {notifications?.length ? (
            notifications.map((notification, idx) => (
              <ListItem disablePadding key={notification.id ?? idx}>
                <ListItemButton onClick={() => handleNavigate(notification)}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="space-between"
                    width="100%"
                    gap={1.5}
                  >
                    {!notification.isRead && (
                      <Box
                        width={10}
                        height={10}
                        sx={{ borderRadius: '50%', mt: 2 }}
                        bgcolor="#d72e29"
                        flexShrink={0}
                      />
                    )}
                    <ListItemText
                      primary={notification.message}
                      sx={{
                        fontWeight: notification.isRead ? 'normal' : 'bold',
                      }}
                    />
                  </Box>
                </ListItemButton>
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No unread notifications" />
            </ListItem>
          )}
        </MUIList>
      </Popover>
    </>
  )
}
